import _ from "lodash";
import moment from "moment";
import { getRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
import { deviceInstalls } from "DashboardDeviceAction";
export var DASHBOARD_TOTAL_NETWORKS = "DASHBOARD_TOTAL_NETWORKS";

export function fetchNetworkAnalytics(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=networking_data&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var threadsdata = response.networkdata;

        var allnetworking = _.filter(
          threadsdata,
          ({ thread }) => thread.newrequesterstatus === "accepted"
        );

        //Filter todays requests
        var threadscreatedToday = _.filter(threadsdata, ({ thread }) =>
          moment().isSame(moment(thread.updateon), "day")
        );

        //Networks Created Today,
        var networkcreatedToday = _.filter(
          threadscreatedToday,
          ({ thread }) => thread.newrequesterstatus === "accepted"
        );

        //callback({error:0,data:{response:threadsdata,count:allnetworking.length}});

        dispatch({
          type: DASHBOARD_TOTAL_NETWORKS,
          payload: { response: threadsdata, count: allnetworking.length },
        });

        dispatch(deviceInstalls(session, callback));
      },
      (error) => {
        callback({ error: 1, data: {} });
      }
    );
  };
}

export function fetchNetworkAnalyticsNew(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=networking_data&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var threadsdata = response.networkdata;

        var allnetworking = _.filter(
          threadsdata,
          ({ thread }) => thread.newrequesterstatus === "accepted"
        );

        //Filter todays requests
        var threadscreatedToday = _.filter(threadsdata, ({ thread }) =>
          moment().isSame(moment(thread.updateon), "day")
        );

        //Networks Created Today,
        var networkcreatedToday = _.filter(
          threadscreatedToday,
          ({ thread }) => thread.newrequesterstatus === "accepted"
        );

        //callback({error:0,data:{response:threadsdata,count:allnetworking.length}});

        dispatch({
          type: DASHBOARD_TOTAL_NETWORKS,
          payload: { response: threadsdata, count: allnetworking.length },
        });
        // dispatch(deviceInstalls(session,callback));

        callback({ error: 0, data: "Networking Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: {} });
      }
    );
  };
}
